// extracted by mini-css-extract-plugin
export var subtitle = "success-module--subtitle--xXcNP";
export var subtitle_icon = "success-module--subtitle_icon--3b5kV";
export var subtitle_text = "success-module--subtitle_text--2GCcE";
export var title = "success-module--title--1a_EI";